/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Pro_AnnualInputs */

const en_plan_pro_annual = /** @type {(inputs: Plan_Pro_AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Annual`)
};

const es_plan_pro_annual = /** @type {(inputs: Plan_Pro_AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Anual`)
};

/**
* | output |
* | --- |
* | "Pro Annual" |
*
* @param {Plan_Pro_AnnualInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_pro_annual = /** @type {((inputs?: Plan_Pro_AnnualInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Pro_AnnualInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_pro_annual(inputs)
	return en_plan_pro_annual(inputs)
});